import { render, staticRenderFns } from "./NewEnquiryTabbed.vue?vue&type=template&id=26135a04&scoped=true"
import script from "./NewEnquiryTabbed.vue?vue&type=script&lang=js"
export * from "./NewEnquiryTabbed.vue?vue&type=script&lang=js"
import style0 from "./NewEnquiryTabbed.vue?vue&type=style&index=0&id=26135a04&prod&scoped=true&lang=css"
import style1 from "./NewEnquiryTabbed.vue?vue&type=style&index=1&id=26135a04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26135a04",
  null
  
)

export default component.exports